import React from 'react';

import { AgencyDetailsPage } from '@components/admin/agency/AgencyDetailsPage';
import { useSearch } from '@hooks/useSearch';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

const searchType = t.type({
  id: h.number().cast(),
});

export const AgencyDetails: React.FC = () => {
  const { search } = useSearch(searchType);
  const agencyId = search.id;

  return <AgencyDetailsPage agencyId={agencyId} isAdmin={true} />;
};
